import {
  RejectRequisitionDocument,
  RejectRequisitionMutation,
  RejectRequisitionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useRejectRequisition = () => {
  const [rejectRequisitionMutation, { loading }] = useMutation(RejectRequisitionDocument, {
    extractorFn: (data: RejectRequisitionMutation) => data.atsMutations.rejectAtsRequisition,
  })

  return {
    loading,
    rejectRequisition(variables: RejectRequisitionMutationVariables) {
      return rejectRequisitionMutation({ variables })
    },
  }
}
